module.exports = __webpack_public_path__ + "static/media/Snare2.b76a6af0.wav";